export default function (response) {
  return response.data
}